// @flow
import SizeInput from './SizeInput'

export default SizeInput
